<template>
  <div style="height: 100%;width: 60%;margin-left: calc(20% - 90px);background-color: #fff;overflow-y: auto;">
    <div style="width: 90%;margin-left: 5%;">
      <el-row style="height: 50px;" />
      <el-row style="height: 70px;font-size: 30px;font-weight: bold;">
        碳 盘 查 报 告
      </el-row>
      <el-row class="summary-title">
        {{reportData.year}}年碳排放概览
      </el-row>
      <el-row style="height: 220px;">
        <el-col span="1" style="height: 100%;" />
        <el-col span="10" style="height: 100%;">
          <el-row style="height: 100px;background-color: rgba(255, 169, 79, 0.2);">
            <el-row style="height: 44px;line-height: 44px;font-size: 18px;">
              碳排放总量 <span style="color: #999999;">tCO<sub>2</sub>e</span>
            </el-row>
            <el-row style="height: 56px;line-height: 56px;font-weight: bold;font-size: 32px;color: #ffa94f;">
              {{dataFormat(reportData.summary[0].data, 2, 1)}}
            </el-row>
          </el-row>
          <el-row style="height: 100px;margin-top: 20px;background-color: rgba(255, 169, 79, 0.2);">
            <el-row style="height: 44px;line-height: 44px;font-size: 18px;">
              折合标准煤总量 <span style="color: #999999;">tce</span>
            </el-row>
            <el-row style="height: 56px;line-height: 56px;font-weight: bold;font-size: 32px;color: #ffa94f;">
              {{dataFormat(reportData.summary[1].data, 2, 1)}}
            </el-row>
          </el-row>
        </el-col>
        <el-col span="1" style="height: 100%;" />
        <el-col span="12" style="font-size: 16px;height: 100%;text-align: center;">
          <el-row style="height: 64px;line-height: 60px;background-color: rgba(86, 163, 239, 0.2);">
            <el-col span="14" style="text-align: center;">碳排强度 <span style="color: #999999;">tCO<sub>2</sub>e / 万元</span></el-col>
            <el-col span="8" style="font-weight: bold;font-size: 28px;color: #56a3ef;">{{dataFormat(reportData.summary[2].data, 2, 1)}}</el-col>
          </el-row>
          <el-row style="height: 64px;margin-top: 14px;line-height: 60px;background-color: rgba(86, 163, 239, 0.2);">
            <el-col span="14" style="text-align: center;">综合能耗强度 <span style="color: #999999;">tce / 万元</span></el-col>
            <el-col span="8" style="font-weight: bold;font-size: 28px;color: #56a3ef;">{{dataFormat(reportData.summary[3].data, 2, 1)}}</el-col>
          </el-row>
          <el-row style="height: 64px;margin-top: 14px;line-height: 60px;background-color: rgba(86, 184, 97, 0.2);">
            <el-col span="14" style="text-align: center;">抵偿植树量 <span style="color: #999999;">棵</span></el-col>
            <el-col span="8" style="font-weight: bold;font-size: 28px;color: #56b861;">{{dataFormat(reportData.summary[4].data, 0, 2, 1)}}</el-col>
          </el-row>
        </el-col>
      </el-row>
      <el-row v-if="barName1.length > 0" class="summary-title">
        分类统计
      </el-row>
      <el-row v-if="barName1.length > 0" style="width: 100%;height: 400px;">
        <common-charts :init-options="initOptions1" :index="202" :key="timestamp" :options="dataData1"
                       autoresize style="width: 100%;height: 100%;" />
      </el-row>
      <el-row v-if="barName2.length > 0" class="summary-title">
        碳源分析
      </el-row>
      <el-row v-if="barName2.length > 0" style="width: 100%;height: 400px;">
        <common-charts :init-options="initOptions2" :index="203" :key="timestamp" :options="dataData2"
                       autoresize style="width: 100%;height: 100%;" />
      </el-row>
      <el-row v-if="barName3.length > 0" class="summary-title">
        碳汇分析
      </el-row>
      <el-row v-if="barName3.length > 0" style="width: 100%;height: 400px;">
        <common-charts :init-options="initOptions3" :index="204" :key="timestamp" :options="dataData3"
                       autoresize style="width: 100%;height: 100%;" />
      </el-row>
      <el-row style="height: 100px;line-height: 60px;font-size: 13px;text-align: left;margin-top: 60px;">
        以上数据，依据标准：ISO 14064-1:2018，《中国行业温室气体排放核算方法与报告指南》，按输入数据计算得出，非企业完整碳排放量，结果仅供参考。
      </el-row>
    </div>
  </div>
</template>

<script>
import CommonCharts from "../../common/chart/CommonCharts";
import buildCarbonBarConfig from "../../../config/chart/config_carbon_bar";
import buildBarConfig from "../../../config/chart/config_cross_bar";
export default {
  name: "CarbonReport",
  props: [ 'reportData' ],
  components: { CommonCharts },
  data() {
    return {
      timestamp: '',
      barName1: [],
      barData1: [],
      barName2: [],
      barData2: [],
      barName3: [],
      barData3: [],
      initOptions1: {
        renderer: 'canvas'
      },
      initOptions2: {
        renderer: 'canvas'
      },
      initOptions3: {
        renderer: 'canvas'
      },
      dataData1: {},
      dataData2: {},
      dataData3: {}
    }
  },
  created() {
    this.dealReportData()
  },
  methods: {
    dataFormat(x, num = 1, trans = 0) {
      if (trans === 0) {
        return parseFloat(x).toFixed(num)
      }
      let res = parseFloat(x)
      let unit = ''
      if (res / 10000 > 1) {
        res = res / 10000
        unit = '万'
        if (res / 10000 > 1) {
          res = res / 10000
          unit = '亿'
        }
      }
      return res.toFixed(num) + unit
    },
    dealReportData() {
      this.barName1 = []
      this.barData11 = []
      this.barData12 = []
      this.barName2 = []
      this.barData2 = []
      this.barName3 = []
      this.barData3 = []
      this.reportData.summaryTy.forEach(item => {
        if (parseFloat(item.data) > 0) {
          this.barName1.push(item.name)
          this.barData11.push(this.dataFormat(item.data))
          this.barData12.push('-')
        }
      })
      this.reportData.summaryTh.forEach(item => {
        if (parseFloat(item.data) > 0) {
          this.barName1.push(item.name)
          this.barData11.push('-')
          this.barData12.push(this.dataFormat(-1 * item.data))
        }
      })
      if (this.barName1.length > 0) {
        this.dataData1 = buildCarbonBarConfig(this.barName1, this.barData11, this.barData12, '碳源', '碳汇')
      }
      this.reportData.ty.forEach(item => {
        if (parseFloat(item.CO2_t) > 0) {
          this.barName2.unshift(item.name)
          this.barData2.unshift(this.dataFormat(item.CO2_t))
        }
      })
      this.reportData.th.forEach(item => {
        if (parseFloat(item.CO2_t) > 0) {
          this.barName3.unshift(item.name)
          this.barData3.unshift(this.dataFormat(item.CO2_t))
        }
      })
      if (this.barName2.length > 0) {
        this.dataData2 = buildBarConfig(this.barName2, this.barData2, '#F0A4A4')
      }
      if (this.barName3.length > 0) {
        this.dataData3 = buildBarConfig(this.barName3, this.barData3, '#B4EFBF')
      }
      this.timeStamp = new Date().getTime()
    }
  }
}
</script>

<style scoped>
  .summary-title {
    height: 40px;
    margin-bottom: 30px;
    margin-top: 30px;
    font-size: 18px;
    font-weight: bold;
    text-align: left;
    border-bottom: 1px solid #cccccc;
  }
</style>



// WEBPACK FOOTER //
// src/components/EnergyEfficiency/CarbonManage/CarbonReport.vue